/* DeckWächter — Deutsch→Englisch Pokémon-Namen (für die pokemontcg.io-Suche).
   Die API kennt nur englische Namen. window.dwPokeQuery("Glurak") -> "Charizard".
   Wort-für-Wort-Ersetzung, damit auch "Glurak VMAX" klappt. */
(function () {
  if (window.dwPokeQuery) return;
  var M = {
    'glumanda':'charmander','glutexo':'charmeleon','glurak':'charizard',
    'schiggy':'squirtle','schillok':'wartortle','turtok':'blastoise',
    'bisasam':'bulbasaur','bisaknosp':'ivysaur','bisaflor':'venusaur',
    'pikachu':'pikachu','raichu':'raichu','pichu':'pichu',
    'evoli':'eevee','aquana':'vaporeon','blitza':'jolteon','flamara':'flareon',
    'psiana':'espeon','folipurba':'espeon','nachtara':'umbreon','blattella':'leafeon',
    'glaziola':'glaceon','feelinara':'sylveon',
    'relaxo':'snorlax','kapuno':'snorlax','karpador':'magikarp','garados':'gyarados',
    'dratini':'dratini','dragonir':'dragonair','dragoran':'dragonite',
    'mauzi':'meowth','enton':'psyduck','pummeluff':'jigglypuff','knofensa':'bellsprout',
    'gengar':'gengar','alpollo':'haunter','nebulak':'gastly',
    'mewtu':'mewtwo','mew':'mew','lugia':'lugia','ho-oh':'ho-oh','hooh':'ho-oh',
    'celebi':'celebi','suicune':'suicune','raikou':'raikou','entei':'entei',
    'rayquaza':'rayquaza','kyogre':'kyogre','groudon':'groudon',
    'latios':'latios','latias':'latias','metagross':'metagross','despotar':'tyranitar',
    'lucario':'lucario','guardevoir':'gardevoir','sniebel':'sneasel','snibunna':'weavile',
    'dialga':'dialga','palkia':'palkia','giratina':'giratina','arceus':'arceus',
    'darkrai':'darkrai','shaymin':'shaymin','heatran':'heatran',
    'reshiram':'reshiram','zekrom':'zekrom','kyurem':'kyurem','victini':'victini',
    'kapu':'tapu','xerneas':'xerneas','yveltal':'yveltal','zygarde':'zygarde',
    'solgaleo':'solgaleo','lunala':'lunala','necrozma':'necrozma',
    'zacian':'zacian','zamazenta':'zamazenta','endynalos':'eternatus',
    'koraidon':'koraidon','miraidon':'miraidon','lapras':'lapras','aerodactyl':'aerodactyl',
    'starmie':'starmie','machomei':'machamp','glibunkel':'gible','knakrack':'garchomp',
    'fukano':'growlithe','arkani':'arcanine','vulpix':'vulpix','vulnona':'ninetales',
    'kadabra':'kadabra','simsala':'alakazam','onix':'onix','stahlos':'steelix',
    'porenta':'porygon','togepi':'togepi','despotar':'tyranitar','milotic':'milotic'
  };
  window.dwPokeQuery = function (q) {
    if (!q) return q;
    return String(q).split(/\s+/).map(function (w) {
      var k = w.toLowerCase().replace(/[.,!?]/g, '');
      return M[k] || w;
    }).join(' ');
  };
})();
